import type { ReactNode } from 'react'
import { Button, Tooltip, makeStyles, tokens } from '@fluentui/react-components'
import { QuestionCircle20Regular } from '@fluentui/react-icons'
import { useNavigate } from 'react-router-dom'
import { HELP_ANCHORS, type HelpTopic } from '../lib/helpAnchors'

const useStyles = makeStyles({
  row: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalXS },
})

/** A "?" that opens one part of Help. */
export function HelpLink({ topic }: { topic: HelpTopic }) {
  const navigate = useNavigate()
  const href = `/help#${HELP_ANCHORS[topic]}`
  return (
    <Tooltip content="Help" relationship="label">
      <Button
        as="a"
        href={href}
        appearance="subtle"
        size="small"
        icon={<QuestionCircle20Regular />}
        onClick={(e) => {
          // Ctrl/Cmd/Shift-click opens a new tab or window, as on any link.
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
          e.preventDefault()
          navigate(href)
        }}
      />
    </Tooltip>
  )
}

/** A page title with a "?" that opens the page's part of Help. The link sits
 *  outside the heading, so screen readers don't read it as part of the title. */
export function TitleWithHelp({ topic, children }: { topic: HelpTopic; children: ReactNode }) {
  const styles = useStyles()
  return (
    <div className={styles.row}>
      {children}
      <HelpLink topic={topic} />
    </div>
  )
}
